import React from 'react';
import { useTranslation } from 'react-i18next';

import { RowDetail } from 'src/components/common';
import { renderSize, renderWeight } from 'src/utils/helper';

type Props = {
  record: Response.EstimatePrice['item'];
  queryTaxes?: Response.TaxesResponse['items'];
  isProductFinished: boolean;
};

const ColumnRender: React.FC<Props> = ({ record, isProductFinished }) => {
  const { t } = useTranslation();

  return (
    <div
      className="container_estimate_results"
      // style={{ maxWidth: 418 }}
    >
      <RowDetail
        title={t('pricing_page.estimate_results.estimate_number')}
        value={record?.webMitrNo}
        layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
        rowClassName="row_item"
      />

      <RowDetail
        title={t('pricing_page.estimate_results.registration_date')}
        value={record?.webMitrTrokub}
        layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
        rowClassName="row_item"
      />

      <RowDetail
        title={t('pricing_page.estimate_results.product_name')}
        value={record?.hakudoShhnm}
        layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
        rowClassName="row_item"
      />

      <RowDetail
        style={{ whiteSpace: 'pre-line' }}
        title={t('pricing_page.estimate_results.size')}
        value={
          !isProductFinished ? renderSize(record, record?.setdnKakoCd) : ''
        }
        layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
        rowClassName="row_item"
      />

      <RowDetail
        title={t('pricing_page.estimate_results.cutting_process')}
        value={record?.setdnKako}
        layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
        rowClassName="row_item"
      />

      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <RowDetail
            title={t('pricing_page.estimate_results.product_number')}
            value={record?.inzu}
            layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
            rowClassName="row_item"
          />
        </div>

        <div style={{ flex: 1 }}>
          <RowDetail
            title={t('pricing_page.estimate_results.weight')}
            value={renderWeight(record?.henkanJury, record?.marumeJury)}
            layout={{ titleCol: { span: 12 }, valueCol: { span: 12 } }}
            rowClassName="row_item"
          />
        </div>
      </div>
    </div>
  );
};

export default ColumnRender;
